<template>
	<div class="under-construction">
		<span class="under-construction__icon" role="img" aria-label="Construction">
			🚧
		</span>
		<h1 class="under-construction__title">Coming Soon</h1>
	</div>
</template>

<style scoped>
.under-construction {
    flex-grow: 1;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	gap: 1rem;
}

.under-construction__icon {
	font-size: 4rem;
	line-height: 1;
}

.under-construction__title {
	font-size: 2rem;
	font-weight: 600;
	letter-spacing: 0.05em;
}
</style>